import React, { Suspense } from 'react';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import UILoader from 'components/UI/Loader/Loader';

const PlacementJsonExport = React.lazy(
  () => import('components/Tools/PlacementJsonExport/PlacementJsonExport'),
);

function ScreensToolsPlacementJsonExport() {
  return (
    <BaseLayout>
      <DocumentTitle>Placement JSON Export by Client</DocumentTitle>
      <UIPageTitle description="Export placement data by month for a client">
        Placement JSON Export by Client
      </UIPageTitle>
      <Suspense fallback={<UILoader />}>
        <PlacementJsonExport />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsPlacementJsonExport;
